import React from "react";
import './Body14.css';
import {Link} from "react-router-dom"
import picture261 from './source/picture261.png'
import picture262 from './source/picture262.png'
import picture263 from './source/picture263.png'





function Body14() {

  return (
    <div className="body14">
      <div className="body14-box1">
        <div className="body14-box2">
          <div className="body14-box3">Staré město</div>
          <div className="body14-box5"><div className="body14-box4"></div></div>
          <div className="body14-box6">
          <img className="body14-box6-picture" src={picture261} alt="picture1"/>
          <img className="body14-box6-picture" src={picture262} alt="picture1"/>
          <img className="body14-box6-picture" src={picture263} alt="picture1"/>
          </div>
          <div className="body14-box8"><div className="body14-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body14;
